import React from 'react';
import { colors } from '../lib/colors';
import { Col, Row } from '../lib/utils';
import SvgIcon from './SvgIcon';

type Props = {
    imageUrl: string | undefined;
    className?: string;
    size?: number;
    imageFill?: string;
    isRealGray?: boolean; // This prop is not used in the current implementation, but can be added for future use
    isWhiteCircle?: boolean;
    iconSize?: number; // This prop is not used in the current implementation, but can be added for future use
    iconWidth?: number; // This prop is not used in the current implementation, but can be added for future use
    iconHeight?: number; // This prop is not used in the current implementation, but can
    circleColor?: string; // This prop is not used in the current implementation, but can be added for future use
};

const NewProfileImage = ({
    imageUrl,
    className,
    size,
    imageFill = '#D2D8DE',
    isRealGray = false,
    isWhiteCircle = false,
    iconSize = 16, // Default icon size
    iconWidth: _iconWidth, // Default icon width
    iconHeight: _iconHeight, // Default icon height
    circleColor = colors.black, // Default circle color
}: Props) => {
    const width = size ? size : 20;
    const height = size ? size : 20;
    const iconWidth = (_iconWidth ? _iconWidth : iconSize) ?? 16;
    const iconHeight = (_iconHeight ? _iconHeight : iconSize) ?? 16;
    return (
        <Row className={className} style={{ width, height, minWidth: width, minHeight: height, overflow: 'hidden' }}>
            {imageUrl ? (
                <img
                    src={imageUrl}
                    style={{
                        width: '100%',
                        height: '100%',
                        borderRadius: '50%',
                    }}
                />
            ) : (
                <Col
                    className=" justify-center items-center"
                    style={{ width: '100%', height: '100%', borderRadius: 50, backgroundColor: circleColor }}
                >
                    <SvgIcon name={'SvgUser'} fill={imageFill} size={iconSize} strokeWidth={1} />
                </Col>
            )}
        </Row>
    );
};

export default NewProfileImage;
// isWhiteCircle
//     ? 'SvgProfileInRealWhiteCircle'
//     : isRealGray
//     ? 'SvgProfileInRealGreyCircle'
//     : 'SvgProfileInGreyCircle'
